const vehicleMarkerPopup = {
  batteryLevel: ' Battery Level', 
  estimatedRange: 'Geschätzte Reichweite',
  chargingStatus: 'Ladestatus',
  charging: 'Laden',
  notCharging: 'Lädt nicht',
  unknown: 'unbekannt',
};

export default vehicleMarkerPopup;